import { PlaceTagApi, placeTagsApi } from "api/placeTagsApi";
import { useEffect, useState } from "react";

export const usePlaceTag = (placeTagId: number) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [data, setData] = useState<PlaceTagApi | null>(null);

  useEffect(() => {
    const fetchPlaceTag = async () => {
      if (!placeTagId) {
        console.error("Place tag id not found.");
        setLoading(false);
        return;
      }
      const res = await placeTagsApi.fetchById(placeTagId);
      try {
        setData(res.data);
      } catch (error) {
        // Handle error appropriately, perhaps with another state variable
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchPlaceTag();
  }, [placeTagId]);

  return { loading, data };
};
